import { DateTimeFormat, DatetimePicker } from "@/components/ui/date-time-picker";
import { useEffect, useState } from "react";
import { useFieldContext } from "../../../../../question/components/organisms/FieldRenderer";


export function DateRenderer() {
    const { question, setFormValue, disabled, response, currentValue } = useFieldContext();
    const [date, setDate] = useState<Date | undefined>(new Date());

    useEffect(() => {
        console.log("[Date] date: ", date);
    }, [date]);

    const fieldDateOptions = question.field_date_options;

    const format: DateTimeFormat = {
        dateFormat: ['years', 'months', 'days'],
        timeFormat: question.field_type === 'dateTime' ? (()=>{
            if(fieldDateOptions?.timeFormat === 'HH:mm') {
                return ['hours', 'minutes']
            }else{
                return ['hours', 'minutes', 'am/pm']
            }
        })() : []
    };

    useEffect(() => {
        if(currentValue) {
            setDate(new Date(currentValue));
            console.log("[Date] currentValue: ", currentValue);
        }
    }, [currentValue]);

    useEffect(() => {
        if (setFormValue) {
            setFormValue(date?.toISOString() || "");
        }
    }, [date, setFormValue]);

    return (
        <div className="">
            {!disabled ? (
                <DatetimePicker
                    value={date}
                    onChange={setDate}
                    format={format}
                    dtOptions={{ 
                        hour12: fieldDateOptions?.timeFormat !== 'HH:mm' ? true : false
                     }}
                />
            ) : (
                <div className="">
                    {(() => {
                        // console.log(response.field_value)
                        if (question?.field_date_options?.['year_only']) {
                            return response?.field_value?.length ? getYear(new Date(response?.field_value)) : ""
                        }
                        return response?.field_value?.length ? formatDate(new Date(response?.field_value)) : ""
                    })()}
                </div>
            )}
        </div>
    )
}

function formatDate(date: Date) {
    return `${date.getDay()}-${date.getMonth()}-${date.getFullYear()}`;
}

function getYear(date: Date) {
    return date.getFullYear();
}